'use client';

import { createContext, type ReactNode, useContext } from 'react';

import { useTeamConfig } from '@/app/(football)/[team]/_context/context';

import { pointLoungeConfig } from './config';
import type { PointLoungePageConfig } from './types';

const PointLoungePageConfigContext = createContext<PointLoungePageConfig | null>(null);

interface Props {
  children: ReactNode;
}

export function PointLoungePageConfigProvider({ children }: Props) {
  const { teamSlug } = useTeamConfig();
  const config = pointLoungeConfig[teamSlug];

  return <PointLoungePageConfigContext.Provider value={config}>{children}</PointLoungePageConfigContext.Provider>;
}

export function usePointLoungePageConfig() {
  const context = useContext(PointLoungePageConfigContext);

  if (!context) {
    throw new Error('usePointLoungePageConfig must be used within PointLoungePageConfigProvider');
  }

  return context;
}
